<template>
  <v-card width="350" class="align-center  d-flex flex-column margin-card">
    <v-card-title>
      <div>
        <v-img :src="require('@/assets/logo-grupo-cometa.svg')"> </v-img>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <h2 class="mb-5">Solicitar redefinição senha</h2>
        <v-text-field
          :rules="[rules.emailCometa]"
          v-model="form.email"
          class="mb-2"
          label="E-mail"
          outlined
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-row class="col-md-12 col-sm-12">
      <v-btn
        @click="sendPasswordRestRequest()"
        block
        :disabled="!valid"
        color="#0d47a1"
        class="mb-2 white--text"
        >Enviar
      </v-btn>
    </v-row>

    <v-overlay :value="load">
      <v-progress-circular size="130" color="white" indeterminate>
        Enviando e-mail...
      </v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import loginService from "../../services/login";
import rules from "../../mixins/inputRules";
export default {
  mixins: [rules],
  data() {
    return {
      valid: true,
      load: false,
      form: {
        email: null
      }
    };
  },
  methods: {
    async sendPasswordRestRequest() {
      try {
        this.load = true;
        await loginService.sendPasswordRestRequest(this.form);
        this.$notify({
          text: "Verifique sua caixa de entrada!",
          type: "success"
        });
      } catch (error) {
        this.$notify({
          text: "erro ao enviar solicitação para redefinição de senha",
          type: "error"
        });
      } finally {
        this.load = false;
      }
    }
  }
};
</script>

<style>
.margin-card {
  margin-bottom: 10%;
}

.margin-form {
  padding: 0;
}
</style>
